<template>
  <main>
    <tab-header />
    <div class="tab-content" :class="{ 'section-loading': checkLoading }">
      <div class="tab-pane active show">
        <form class="form">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="radio radio-inline">
                  <input type="radio" id="reviewType1" name="reviewType" v-model="reviewType" value="1">
                  <label for="reviewType1">調撥對象</label>
                </div>
                <!-- <div class="radio radio-inline">
                  <input type="radio" id="reviewType2" name="reviewType" v-model="reviewType" value="2">
                  <label for="reviewType2">調撥進度</label>
                </div> -->
                <hr/>
              </div>
              <div class="col-12">
                <div class="float-right mt-5">
                  <div class="mb-line"><span class="font-weight-bold mr-2">維護單位</span> <span>業務企劃科</span></div>
                  <div class=""><span class="font-weight-bold mr-2">聯絡電話</span> <span>(02)27551399</span></div>
                  <div class="mb-line"><span class="font-weight-bold mr-2">聯絡分機</span> <span>{{ contactInfo.contact_tel }}</span></div>
                </div>
                <h4 class="text-green">選擇撥出對象
                  <a
                    class="text-orange ml-4"
                    style="cursor:pointer;font-size:16px;"
                    @click="download()"
                  >
                    <i class="icon-attach"></i>
                    <b>服務件調撥操作手冊</b>
                  </a>
                </h4>
                <div class="form-group row dial-form mb-3" data-index="4"
                :class="{
                  'is-select active': showOutSelection && showOutSelection.length
                }">
                  <label for="" class="col-4">以撥出類別、對象別篩選⬇︎</label>
                  <div v-if="forOutHanlinkUpdate" class="col-8">
                    <span class="text" style="color:green;font-weight: bold;" 
                    v-for="(item, index) in showOutSelection" 
                    :key="`dialOut-${index}`">
                      {{ item }} | 
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <section class="insurance-table newTable">
              <table class="table datatable table-striped table-bordered">
                <thead>
                  <tr>
                    <th width="60" class="text-center">
                      <div class="checkbox checkbox-inline mr-0">
                        <input type="checkbox" name="check-all" 
                        id="check-all"
                        @click="checkAllClick = true"
                        v-model="outCheckAll"
                        disabled>
                        <label for="check-all"></label>
                      </div>
                    </th>
                    <th width="120">現行收費人員</th>
                    <th>收費代號</th>
                    <th >職級</th>
                    <th width="120" class="text-right">年資</th>
                    <th class="text-right">服務件數(要保人數)</th>
                    <th class="text-right">近一年平均產能</th>
                    <th width="130" class="text-center">備註</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dialOutMemberList" :key="`out-${index}`">
                    <td width="60">
                      <div class="mr-0 checkbox checkbox-inline">
                        <input
                        type="checkbox"
                        :id="`check-out-${index}`"
                        :value="item.clcno"
                        v-model="outSelection"
                        @click="doCheckIntrId(item)"
                        :disabled="isAllDisable || (!currentOutClcno ? false : (currentOutClcno != item.clcno))">
                        <label :for="`check-out-${index}`"></label>
                      </div>
                    </td>
                    <td>{{ item.ceempnm }}</td>
                    <td>{{ item.clcno }}</td>
                    <td>{{ item.cepsnnm }}</td>
                    <td class="text-right">{{ item.syear }}年</td>
                    <td class="text-right">{{item.tmp0}} ({{ item.tmp6 }})</td>
                    <td class="text-right">{{ item.t1workagent }}</td>
                    <td>{{ item.intr_id ? '前一收費人員於2023/13工後入職' : '' }}</td>
                  </tr>
                </tbody>
              </table>
            </section>
            

            <div class="row">
              <div class="col-12">
                <h4 class="text-green">選擇撥入對象</h4>
                
                <div class="form-group row dial-form mb-3" data-index="6"
                :class="{
                  'is-select active': dialIn.clcno && dialIn.clcno.length
                }">
                  <label for="" class="col-3 text-right">以撥入類別、對象別篩選⬇︎</label>
                  <div class="col-9">
                    <span v-if="forInHanlinkUpdate" class="text" style="color:green;font-weight: bold;" >
                      {{ dialIn.clcno }} 
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <section class="insurance-table newTable">
              <table class="table datatable table-striped table-bordered">
                <thead>
                  <tr>
                    <th width="60" class="text-center">
                      <!-- <div class="checkbox checkbox-inline mr-0">
                        <input type="checkbox" name="check-all-in" 
                        id="check-all-in"
                        v-model="inCheckAll">
                        <label for="check-all-in"></label>
                      </div> -->
                    </th>
                    <th width="120">現行收費人員</th>
                    <th>收費代號</th>
                    <th >職級</th>
                    <th width="120" class="text-right">年資</th>
                    <th class="text-right">服務件數(要保人數)</th>
                    <th class="text-right">近一年平均產能</th>
                    <th width="130" class="text-center">備註</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dialInMemberList" :key="`in-${index}`">
                    <td width="60">
                      <div class="mr-0 checkbox checkbox-inline">
                        <input
                        type="radio"
                        :id="`check-in-${index}`"
                        :value="item.ceempnm +'|'+ item.clcno +'|'+ item.cepsndg +'|'+ item.agidno"
                        v-model="dialIn.clcno"
                        @click="checkAllClick = false"
                        :disabled="isAllDisable || (!currentInClcno ? false : (currentInClcno != item.clcno))">
                        <label :for="`check-in-${index}`"></label>
                      </div>
                    </td>
                    <td>{{ item.ceempnm }}</td>
                    <td>{{ item.clcno }}</td>
                    <td>{{ item.cepsnnm }}</td>
                    <td class="text-right">{{ item.syear }}年</td>
                    <td class="text-right">{{item.tmp0}} ({{ item.tmp6 }})</td>
                    <td class="text-right">{{ item.t1workagent }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </section>
            
            <div class="col-12 text-right">
              <a @click="summitToAnotherPage()" class="btn btn-primary" :disabled="isAllDisable">
                下一步
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>

    <Notice-modal
    :open="NoticeModalOpen"
    :message="noticeMsg"
    @close="goNextStep"
    />

    <Warning-modal
    v-if="!isAllDisable"
    :open="WarningModalOpen"
    :message="warningMsg"
    @submit="confirmChangeDailIn"
    @close="cancelChangeDailIn"
    />

    <warning-modal
    v-if="isAllDisable"
    :open="WarningModalOpen"
    :message="warningMsg"
    :showCancel="false"
    @submit="panelClose('WarningModalOpen')" />

    <unlock-resign-modal
      :confirmModalOpen="confirmModalOpen"
      :resignInfo="resignInfo"
      page="submanger"
      @close="panelClose('confirmModalOpen')"
      @close-all="panelClose('confirmModalOpen')"
    />
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import { getInTransferMember, getOutTransferMember, downloadFile_b1, checkFinishClass, getContactInfoBySerNo} from '@/service'
import TabHeader from '@/desktop/components/manager/TabHeader'
import WarningModal from '@/desktop/components/WarningModal'
import NoticeModal from '@/desktop/components/NoticeModal'
import UnlockResignModal from "@/desktop/components/manager/UnlockResignModal";

export default {
  name: 'subTransferTab1',
  mixins: [commonMixin],
  components: {
    TabHeader,  WarningModal, NoticeModal, UnlockResignModal
  },
  computed: {
    ...mapGetters([
      
    ])
  },
  data () {
    return {
      forInHanlinkUpdate: true, // for 難字更新
      forOutHanlinkUpdate: true, // for 難字更新
      outCheckAll: false, //撥出全選
      outSelection:[], //列表陣列
      showOutSelection: [],
      reviewType: 1,
      NoticeModalOpen: false,
      WarningModalOpen: false,
      noticeMsg:'',
      warningMsg:'',
      checkAllClick: false,
      inCheckAll: false,
      dialInMemberList:[], //撥入類別
      dialOutMemberList:[], //撥出類別
      inclcno:'', //撥入代號
      inceempnm:'', //撥入人
      incepsndg:'', //撥入人職級代號
      inagidno:'', //撥入人ID
      cedvno3:'',
      dialOutRemoteDataMsg: "資料讀取中，請稍候...",
      dialOutScrollDataLoading: false,
      dialIn: {
        clcno: '',
        ceempnm: '',
        cepsndg: ''
      },
      queryData:{
        dialInName:'',
        dialInCode:'',
        condictions:{}
      },
      checkRes:{
        getInTransferMember: false,
        getOutTransferMember: false
      },
      isAllDisable: false,
      isManager: this.$store.state.userInfo.divNo.slice(2, 3).match("1|4"),
      contactInfo: [],
      confirmModalOpen: false,
      resignInfo: {},
      currentOutClcno: "",
      currentInClcno: ""
    }
  },
  computed: {
    checkLoading(){
        if(this.checkRes.getInTransferMember == true && 
            this.checkRes.getOutTransferMember == true){
              return false
        }else{
              return true
        }
      }
  },
  watch: {
    showOutSelection () {  // for 難字更新
      this.forOutHanlinkUpdate = false
      setTimeout(() => {
        this.forOutHanlinkUpdate = true
        this.registerHanlink()
      }, 20);
    },
    'dialIn.clcno': function () {  // for 難字更新
      this.forInHanlinkUpdate = false
      setTimeout(() => {
        this.forInHanlinkUpdate = true
        this.registerHanlink()
      }, 20)
    },
    outCheckAll: function(val){
      if(val && this.checkAllClick) {
        this.outSelection = []
        this.dialOutMemberList.forEach(data => {
          this.outSelection.push(data.clcno)
        });
      } else if(this.checkAllClick){
        this.outSelection = []
      }
    },
    outSelection: function(){
      if(this.dialOutMemberList.length !== this.outSelection.length && !this.checkAllClick){
        this.outCheckAll = false
      }else if(!this.checkAllClick){
        this.outCheckAll = true
      }
      this.updateShowOutSelection()
    },    

  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    confirmChangeDailIn() {
      this.WarningModalOpen = false
    },
    cancelChangeDailIn () {
      this.WarningModalOpen = false
    },
    updateShowOutSelection() {
      this.showOutSelection = []
      this.dialOutMemberList.map(mem => {
        if(this.outSelection.includes(mem.clcno)) {
          this.showOutSelection.push(mem.ceempnm + " " + mem.clcno)
        }
      })
    },
    getTransferMember(){

      let divNo = this.$store.state.userInfo.divNo
      const last4 = this.$store.state.userInfo.divNo.substr(-4) // divNo取末四碼
      const last3 = this.$store.state.userInfo.divNo.substr(-3) // divNo取末三碼
      const last2 = this.$store.state.userInfo.divNo.substr(-2) // divNo取末二碼
      const index45 = this.$store.state.userInfo.divNo.slice(3,5) // divNo 取第四、五碼
      const index3 = this.$store.state.userInfo.divNo.slice(2,3) // divNo 取第三碼
      const index4 = this.$store.state.userInfo.divNo.slice(3,4) // divNo 取第四碼
      const positionFirst1 = this.$store.state.userInfo.position.slice(0,1) // position取第一碼
      let clcno5 ='';
      const testPat1 = /0000/
      const testPat2 = /000/
      const testPat3 = /00/

      if(testPat1.test(last4) && positionFirst1 == 'G'){
         if(index3 == '4'){
             clcno5 = divNo.slice(0,2) + '5'
         }else{
             clcno5 = divNo.slice(0,3)
         }    
      }else if(testPat2.test(last3) && index3 != '1'){
         if(index3 =='4'){
             clcno5 =  divNo.slice(0,2) + '5' + index4
         }else{
             clcno5 =  divNo.slice(0,4) 
         }
      }else if(testPat3.test(last2)){
         if(index3 =='4'){
              clcno5 = divNo.slice(0,2) + '5' + index45
         }else{
              clcno5 = divNo.slice(0,5) 
         }
      }else{
           clcno5 = ''
      }
      let cedvno3 = this.$store.state.userInfo.divNo.slice(0,3)
          this.checkRes.getInTransferMember = false
          getInTransferMember(this.$store.state.userInfo.id, cedvno3, clcno5).then(result => { //撥入對象
            if(result && result.header.status == '200' && result.body){
              this.dialInMemberList = result.body.ag
            }else{
              console.error('撥入類別、對象別載入異常')
            }
            this.checkRes.getInTransferMember = true
            this.registerHanlink()
          }),
          this.checkRes.getOutTransferMember = false
          getOutTransferMember(this.$store.state.userInfo.id, cedvno3, clcno5).then(result => { //撥出對象
            if(result && result.header.status == '200' && result.body){
              this.dialOutMemberList = result.body.ag
            }else{
              console.error('撥出類別、對象別載入異常')
            }
            this.checkRes.getOutTransferMember = true
            this.registerHanlink()
          })

      //是否至國泰學習網完成調訓課程
      if(this.isManager){
        const userCategoryId  = this.$store.state.userInfo.userCategoryId
        const classId = this.getClassId(userCategoryId)
        checkFinishClass(this.$store.state.userInfo.id, classId, userCategoryId).then(result => {
          if (result && result.header.status == "200" && result.body) {
            var lists = result.body.lists;
            if (lists && lists.length == 0) {
              this.warningMsg = `<h4 class="text-green">請至國泰學習網完成調訓課程，如未完成將無法使用調撥功能。
                                  </br></br>
                                  課程路徑:
                                  <a target="_blank" style="color:blue;" href='https://cathay.elearn.com.tw/dist/index.html#/courseResourceCatalog/12022?nid=20103&mid=5959'>
                                    國泰學習網/課程/業務人員課程/行銷學院/數位工具/CRM2.0
                                  </a>
                                  ，【CRM2.0】服務件調撥操作教學-經理 或 課長/組訓/區處主管版。
                                </h4>`;
              this.panelOpen("WarningModalOpen");
              
              //disable畫面功能
              this.isAllDisable = true;
            }
          }
        });
      }
    },
    getClassId(categoryId){
      const mapping = {
        'A013': '36061',
        'A043': '36061',
        'A015': '36062',
        'A019': '36062',
        'A044': '36062',
        'A045': '36062'
      }
      return mapping[categoryId] || '';
    },
    checkData () {  // 選取撥入對象
      let dialInData  = this.dialIn.clcno.split('|')
      this.inceempnm = dialInData[0]
      this.inclcno = dialInData[1]
      this.incepsndg = dialInData[2]
      this.inagidno = dialInData[3]
      let clcnoCheck = false
        if(this.outSelection.indexOf(this.inclcno) > -1){ //判斷撥出撥入是否有相同
          clcnoCheck = true
        }
        if(clcnoCheck){ // 如果撥入撥出收費代號重複
          this.warningMsg = `選擇撥出與撥入同仁有重複，請再次確認`
          this.WarningModalOpen = true
          return false
        }else if(this.inclcno == null || this.outSelection.length == 0){ //判斷撥出撥入是否勾選
           this.warningMsg = '請選擇至少一位欲撥出及撥入服務件之同仁'  
           this.WarningModalOpen = true
           return false
        }else{
           return true
        }
    },    
    setQueryData(){
      var commit_check = false
      var dialInCheck = false
      var dialOutCheck = false
      var code = ''
      const cedvno = this.$store.state.userInfo.divNo.slice(0,3)
      //判斷撥入人員類別
      if(this.inclcno != null){
        console.log("dialIn.preson");
        code = this.inclcno
        dialInCheck = true
      }
      if(this.inceempnm){
        console.log("dialIn.selected");
        code = this.inceempnm
        dialInCheck = true
      }
      
      if(this.outSelection != null){
        console.log('type = 6')  
        this.queryData.condictions = {
          type: "6",
          cedvno3: cedvno,
          clcno_old_list: this.outSelection,
          clcno_new: this.inclcno,
          inagidno:this.inagidno,
          incepsndg:this.incepsndg
        }
        dialOutCheck = true
        commit_check = true
      }
      return commit_check
    }, 
    summitToAnotherPage(){ //導頁至服務件列表
      if(this.checkData()){
        const check = this.setQueryData()
        if(this.inclcno !== null){  // 以撥入人員篩選時
          this.queryData.dialInName = this.inceempnm //業務員名稱
          this.queryData.dialInCode = this.inclcno//收費代號
        }
          if(check){
            //若撥入人員為CA，跳出提示視窗
            if(this.incepsndg == 'OT' || this.incepsndg == 'OJ' || this.incepsndg == 'OG') {
              this.noticeMsg = "<h2 class='text-green'>注意事項</h2><b>你選擇的撥入對象為『CA人員』，故在保單調撥畫面僅會顯示<span class='text-red'>『該CA人員招攬的保單』</span>，供主管調撥。</b>";
              this.NoticeModalOpen = true;
            } else {
              this.goNextStep();
            }
          }
        }
     },
    download () {
      let vm = this;
      downloadFile_b1(this.$store.state.userInfo.id, 2, 'sub_manager.pdf').then(
        result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, 'sub_manager.pdf');
          }
        }
      );
    },
    goNextStep () {
      this.$store.dispatch('setRouterPara', {pathName:'managerTabOne', setData: this.queryData});
      this.$router.push({ path: '/manager/tab/1/filter' });
    },
    getContactInfo(){
      // 以流水編號查詢企劃單位連絡方式
      getContactInfoBySerNo(this.$store.state.userInfo.id, '11').then(result => {
        if(result && result.header.status == '200' && result.body){
            this.contactInfo  = result.body.lists[0];
        }
      })
    },
    /**
     * 確認是否有增員者
     * @param {Object} obj 當前值
     */
    doCheckIntrId(obj) {
      this.checkAllClick = false;

      if (obj.intr_id) {
        this.currentOutClcno = "";
        this.currentInClcno = "";
        this.dialIn.clcno = "";

        if (!this.outSelection.includes(obj.clcno)) {
          this.outSelection = [obj.clcno];
          this.currentOutClcno = obj.clcno;
          this.resignInfo = obj;
          this.panelOpen("confirmModalOpen");

          const dailInIntr = this.dialInMemberList.find(e => e.agidno == obj.intr_id);
          if (dailInIntr && !obj.mgr_id) {
            this.currentInClcno = dailInIntr.clcno;
            this.dialIn.clcno = dailInIntr.ceempnm +'|'+ dailInIntr.clcno +'|'+ dailInIntr.cepsndg +'|'+ dailInIntr.agidno;
          }
        }
      }
    }
  },
  beforeMount () {
  },
  mounted () {
    this.getTransferMember()
    this.getContactInfo()
  }
}
</script>
